import { Link } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useRelatedOrders } from '@/hooks/api/0640_related_orders';
import { Fragment } from 'react';
import { SalesOrderLogic } from '@/hooks/api/models/logics';
import { MotionDiv } from '@/components/element/MotionDiv';

export const RelatedProjects = () => {
  const { _w_, _t_, me, meTeamMember, isTeamAdmin, isApprover, isFinancialOfficer, isBackoffice, isMember } =
    useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { data: relatedOrders } = useRelatedOrders({ identifier: _w_!.identifier, team_id: _t_!.id, id: _po_!.id });

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">関連プロジェクト（売上）一覧</h6>
        </div>
        <Link
          to={`/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/related_projects`}
          className="btn btn-outline-success btn-icon-only"
        >
          <i className="fas fa-edit"></i>
        </Link>
      </div>
      <div className="card-body pt-0">
        {relatedOrders?.map((d, i) => (
          <Fragment key={`ro-${d.id}`}>
            {i != 0 && <hr className="horizontal dark" />}
            <Link
              to={`/w/${_w_!.identifier}/teams/${d.sales_order_outline.team_id}/sales_orders/${
                d.sales_order_outline.id
              }`}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center">
                <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                  <i className="fas fa-project-diagram text-white"></i>
                </div>
                <div className="ms-2">
                  <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.sales_order_outline.name}</div>
                  <div className="text-muted font-weight-bold text-xs">
                    {d.sales_order_outline.business_partner_display_name}, ¥
                    {SalesOrderLogic.totalAmount(d.sales_order_outline).toLocaleString()}
                  </div>
                </div>
              </div>
              <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
            </Link>
          </Fragment>
        ))}
      </div>
    </MotionDiv>
  );
};
